import {LOAD_BOUGHT_CASES, BUY_CASE, JUST_BOUGHT_RESET} from "./actions";
import {LOAD_CASES} from "../../CaseSelector/store/actions";

const initialState = {
	boughtCases: [],
	justBought: false
};

const reducer = (state = initialState, action) => {
	switch (action.type) {

		case BUY_CASE:
			return {...state, boughtCases: state.boughtCases.concat(action.boughtCase), justBought: true};
		case LOAD_BOUGHT_CASES:
			return {...state, boughtCases: action.cases.casesPurchased};
		case LOAD_CASES:

			const boughtCase = action.cases
				.filter(currentCase => currentCase.purchased)
				.map(currentCase => currentCase.caseId);

			return {...state, boughtCases: boughtCase};
		case JUST_BOUGHT_RESET:
			return {...state, justBought: false};
		default:
			return state;
	}
};

export default reducer;


// WEBPACK FOOTER //
// ./src/components/Purchases/store/reducer.js